let lastScroll = 0;
const initCalendar = () => {
  if(document.querySelector('.yo-appointment-calendar')) {
    const tabEl = document.querySelector('button[data-bs-toggle="pill"]')
    tabEl.addEventListener('hide.bs.tab', event => {
      document.querySelectorAll('.yo-week-title').forEach(ele => {
        ele.classList.toggle('d-none');
      })
    });
    tabEl.addEventListener('show.bs.tab', event => {
      document.querySelectorAll('.yo-week-title').forEach(ele => {
        ele.classList.toggle('d-none');
      })
    });
  }
};
export default initCalendar;
